var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.102 7.797c1.726 0 3.171-1.531 3.171-3.492 0-1.914-1.453-3.399-3.171-3.399-1.72 0-3.172 1.508-3.165 3.414 0 1.946 1.438 3.477 3.165 3.477Zm-9.055.172c1.5 0 2.766-1.336 2.766-3.04 0-1.663-1.274-2.96-2.766-2.96S3.28 3.289 3.289 4.945c0 1.688 1.258 3.024 2.758 3.024Zm-4.274 7.117H7.57c-.843-1.203.016-3.563 1.828-4.992-.851-.547-1.976-.946-3.351-.946-3.469 0-5.766 2.555-5.766 4.649 0 .812.399 1.289 1.492 1.289Zm8.485 0h9.687c1.32 0 1.774-.422 1.774-1.156 0-2.008-2.57-4.758-6.617-4.758-4.055 0-6.618 2.75-6.618 4.758 0 .734.446 1.156 1.774 1.156Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.cc3c476bc1ef03aa3a528d13cde4d6ff.svg";
export { ForwardRef as ReactComponent };